// Generated by ReScript, PLEASE EDIT WITH CARE

import * as MmiAssetsManager$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/map-my-India/assets/MmiAssetsManager.bs.js";
import * as OrderDashboardAssetsManager from "../../../../assets/OrderDashboardAssetsManager.bs.js";

var four_wheeler_icon = OrderDashboardAssetsManager.getImage("four_wheeler_map_icon.svg");

var three_wheeler_icon = OrderDashboardAssetsManager.getImage("three_wheeler_map_icon.svg");

var two_wheeler_icon = OrderDashboardAssetsManager.getImage("two_wheeler_map_icon.svg");

var pickup_icon = MmiAssetsManager$Catalyst.getImage("pickup-location-icon.svg");

var drop_icon = MmiAssetsManager$Catalyst.getImage("drop-location-icon.svg");

var start_icon = MmiAssetsManager$Catalyst.getImage("start-trip-icon.svg");

var accept_icon = MmiAssetsManager$Catalyst.getImage("accept-trip-icon.svg");

var cancel_icon = MmiAssetsManager$Catalyst.getImage("cancel-trip-icon.svg");

var end_trip_icon = MmiAssetsManager$Catalyst.getImage("end-trip-icon.svg");

var single_holder_icon = MmiAssetsManager$Catalyst.getImage("single-holder.svg");

var multi_holder_icon = MmiAssetsManager$Catalyst.getImage("multi-holder.svg");

var primaryPolylineColour = "#1E90FF";

var secondaryPolylineColour = "#A31919";

export {
  four_wheeler_icon ,
  three_wheeler_icon ,
  two_wheeler_icon ,
  pickup_icon ,
  drop_icon ,
  start_icon ,
  accept_icon ,
  cancel_icon ,
  end_trip_icon ,
  single_holder_icon ,
  multi_holder_icon ,
  primaryPolylineColour ,
  secondaryPolylineColour ,
  
}
/* four_wheeler_icon Not a pure module */
